import { render, staticRenderFns } from "./realtimetimetable.vue?vue&type=template&id=97be2226&"
import script from "./realtimetimetable.vue?vue&type=script&lang=js&"
export * from "./realtimetimetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports